module.exports = __webpack_public_path__ + "static/media/talentai-LT.083e5aef.SVG";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/talentai-LT.SVG
// module id = 687
// module chunks = 0